import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import './localization';
import { redux } from './store';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement!);

root.render(
    <Provider store={redux}>
        <App />
    </Provider>,
);
